<template>
  <div class="inspection-device-manage">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addPageName" v-if="permissionCodes.indexOf('024002001') !== -1"/>
        <button-upload
          :cathUrl="uploadUrl"
          :onSuccess="onUploadSuccess"
          @getpage="getPage"
          v-if="permissionCodes.indexOf('024002004') !== -1"
          value="导入"/>
        <button-export
          :href="exportUrl"
          :beforeDownload="beforeDownload"
          download="download.xls"
          v-if="permissionCodes.indexOf('024002005') !== -1"
          value="导出"/>
        <!--<button-export-->
          <!--:href="exportTipUrl"-->
          <!--:beforeDownload="beforeTipDownload"-->
          <!--download="download.xls"-->
          <!--value="导出标签"/>-->
      </div>
      <div style="display: flex;justify-content: flex-start">
        <input-select selectTitle="巡检类目" :selectKey="'categoryCode'" selectWidth="180px" :selectData="categoryList" @search="search"/>
        <input-select selectTitle="运行状态" :selectKey="'status'" style="margin-left: 10px;" selectWidth="180px" :selectData="deviceStatusList" @search="search"/>
      </div>
      <input-search placeholder="巡检点名称" @search="searchKey" />
    </div>

<!--    <div class="search-line">-->
<!--      <div style="display: flex;justify-content: flex-start">-->
<!--        <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">质保截止日期</span>-->
<!--        <el-date-picker v-model="timevalue" size="small" type="daterange" style="width: 280px;"-->
<!--                        :picker-options="pickerOptions2" range-separator="至"-->
<!--                        start-placeholder="开始日期" end-placeholder="结束日期"-->
<!--                        align="right" value-format="yyyy-MM-dd">-->
<!--        </el-date-picker>-->
<!--      </div>-->
<!--      -->
<!--    </div>-->

    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :deleteTipInfo="'是否确认删除该巡检点？'" @goToModifyPage="toModifyPage" @deleteLine="deleteLine" @changeSelection="changeSelection" @changeSwitch="changeSwitch" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination"  @getDeviceCodeTip="getDeviceCodeTip" :tableOperationWidth="'180px'" :operationArr="operationArr" :operationFixed="'right'"/>

    <el-dialog
      title="标签"
      :visible.sync="tipDialogVisible"
      width="40%">
      <div style="margin: 20px 0;" ref="imageWrapper">
        <canvas class="qrcode" ref="qrCodeUrl" id="createCode"></canvas>
        <div style="width: 280px;margin: 0 auto;text-align: center;font-size: 18px;" >{{currentElectricDeviceName}}</div>
      </div>
      <el-button size="mini" plain @click="setImage">保存图片</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="closeTipDialogVisible">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import QrCodeWithLogo from 'qr-code-with-logo'
  import html2canvas from 'html2canvas'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/Inspection'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'inspection-device-manage',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧巡检',
          name: 'inspection-device-type-manage'
        }, {
          value: '巡检点管理'
        }],
        addPageName: 'inspection-device-add',
        uploadUrl: '',
        exportUrl: '',
        exportTipUrl: '',
        timevalue: [],
        tableHead: [{
          prop: 'pointName',
          label: '巡检点名称',
        }, {
          prop: 'pointCode',
          label: '巡检码',
        }, {
          prop: 'categoryName',
          label: '巡检点类目',
        }, {
          prop: 'location',
          label: '巡检点位置',
        }, {
          prop: 'desc',
          label: '备注',
        }, {
          prop: 'isPhotoStatus',
          isSwitch: true,
          label: '是否启用拍照',
        }, {
          prop: 'pointStatus',
          explain: 'faultDesc',
          isStatusHasExplain: true,
          label: '运行状态'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        deviceStatusList: [
          {
            key: '',
            label: '全部'
          }, {
            key: '0',
            label: '正常'
          }, {
            key: '1',
            label: '故障'
          }
        ],
        categoryList: [],
        requestData: {
          status: '',
          searchKey: '',
          categoryCode: ''
        },
        operationArr: ['modify', 'delete'],
        windowLeftBox: false,
        pickerOptions2: {
          disabledDate (time) {
            return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
          },
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        electricityTableHead: [],
        electricityTableData: [],
        electricDeviceCode: '',
        electricityTotal: 0,
        electricityPageSize: 10,
        electricityPageNum: 1,
        electricityTimeArr: [],

        electricList: [],

        tipDialogVisible: false,
        tipContent: '',
        currentElectricDeviceName: ''
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.uploadUrl = api.importInspectDevice
      // this.exportUrl = `${api.exportElectricMeter}?yq-app-code=${bus.global.yqCode}&kj-type=gy`
      this.getPage()
      this.getCreateTime()
      this.getInspectDeviceTypeList()
      // this.getElectricManagerList()
      // this.getElectricSceneList()
    },
    activated() {
      this.getInspectDeviceTypeList()
      this.getPage()
    },
    methods: {
      beforeDownload () {
        this.exportUrl = `${api.exportInspectDevice}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&status=${this.requestData.status}&categoryCode=${this.requestData.categoryCode}`
      },
      beforeTipDownload () {
        this.exportTipUrl = `${api.exportCodeScanning}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&status=${this.requestData.status}&categoryCode=${this.requestData.categoryCode}`
      },

      // 获取巡检类目
      getInspectDeviceTypeList () {
        this.$axios.get(api.getInspectDeviceTypeList, {})
          .then(res => {
            let list = res.data.data
            list.map(v => {
              v.key = v.code
              v.label = v.name
            })
            list.unshift({
              key: '',
              label: '全部'
            })
            this.categoryList = list
          })
          .catch(errorHandler('获取巡检类目失败'))
      },

      getCreateTime () {
        let nowDate = new Date
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
        let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
        let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
        let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
        this.electricityTimeArr[0] = year + '-' + month + '-' + date + ' ' + '00:00:00'
        this.electricityTimeArr[1] = year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
        // this.timevalue[0] = year + '-' + month + '-01'
        // this.timevalue[1] = year + '-' + month + '-' + date
      },
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        // if (this.timevalue) {
        //   this.requestData.startTime = this.timevalue[0]
        //   this.requestData.endTime = this.timevalue[1]
        // } else {
        //   this.requestData.startTime = ''
        //   this.requestData.endTime = ''
        // }
        this.$axios.post(api.getInspectDevicePage, reqData)
          .then(res => {
            let data = res.data.data.list
            data.map(v => {
              if (v.isPhoto === '1') {
                v.isPhotoStatus = true
              } else {
                v.isPhotoStatus = false
              }
              if (v.status === '1') {
                v.pointStatus = '0'
              } else {
                v.pointStatus = '1'
              }
            })
            this.total = res.data.data.total
            this.tableData = data
          })
          .catch(errorHandler('获取巡检点数据失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      onUploadSuccess (data) {
        if (data.retCode == 1) {
          nSuccess('导入成功')
          this.pageSize = 10
          this.pageNum = 1
          this.getPage()
        } else {
          errorHandler('导入失败')(data)
        }
      },

      toModifyPage (code) {
        this.$router.push({
          path: `/inspection_device_modify/${code}`
        })
      },
      deleteLine (code) {
        this.$axios.post(api.deleteInspectDevice, code)
          .then(res => {
            nSuccess('删除成功')
            this.getPage()
          })
          .catch(errorHandler('删除失败'))
      },
      // 生成巡检点二维码
      getDeviceCodeTip (data) {
        this.tipDialogVisible = true
        this.tipContent = data.pointCode
        this.currentElectricDeviceName = data.pointName
        this.getCodes()
      },
      getCodes () {
        setTimeout(() => {
          QrCodeWithLogo.toCanvas({
            canvas: document.getElementById('createCode'),
            content: this.tipContent,
            width: 200,
          })
            .catch()
        }, 100)
      },
      closeTipDialogVisible () {
        this.tipDialogVisible = false
      },


      setImage () {
        let that = this
        html2canvas(this.$refs.imageWrapper).then(canvas => {
          let image = canvas.toDataURL("image/jpeg")
          let $a = document.createElement('a')
          $a.setAttribute("href", image)
          $a.setAttribute("download", that.currentElectricDeviceName)
          $a.click()
        })
      },


      changeSwitch (data) {
        this.$confirm('是否确认修改启用状态？', '提示')
          .then(() => {
            if (data.isPhotoStatus) {
              data.isPhoto = '1'
            } else {
              data.isPhoto = '0'
            }
            for (let i in data) {
              if (data[i] === '--') {
                data[i] = ''
              }
            }
            this.$axios.post(api.updateInspectDevice, data)
              .then(res => {
                nSuccess('修改成功')
                this.getPage()
              })
              .catch(errorHandler('修改失败'))
          })
          .catch(() => {
            this.getPage()
          })
      },
    },
    watch: {
      electricityTimeArr (val) {
        this.getElectricityPage()
      },
      timevalue (val) {
        this.pageSize = 10
        this.pageNum = 1
        this.getPage()
      },
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .inspection-device-manage {
    .el-date-editor .el-range-separator {
      padding: 0;
    }
  }

  .el-input--small .el-input__inner {
    line-height: 30px;
  }

  .right-slide-enter,
  .right-slide-leave-active {
    transform: translateX(100%);
  }

  .right-slide-leave-active,
  .right-slide-enter-active {
    transition: all 0.3s;
  }

  .window-left-box {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    width: 50%;
    z-index: 10;
  }
  .window-left-box .move-enter-active, .window-left-box .move-leave-active {
    transition: all 2s linear;
    transform: translate3d(0, 0, 0);
  }
  .window-left-box .move-enter, .window-left-box .move-leave {
    transform: translate3d(100%, 0, 0);
  }
  .window-left-main {
    width: 100%;
    height: 100%;
    z-index: 30;
    background: #FFFFFF;
    padding: 10px;
    overflow: auto;
  }

  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    opacity: .4;
    z-index: -1;
    background-color: #000000;
    transition: opacity .5s ease;
  }

  #createCode {
    display: block;
    width: 180px !important;
    height: 180px !important;
    margin: 0 auto;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/view/Inspection/InspectionDevice/InspectionDeviceManage.vue